import { render, staticRenderFns } from "./TablePager.vue?vue&type=template&id=4ae2f811"
import script from "./TablePager.vue?vue&type=script&lang=js"
export * from "./TablePager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports